export const NavigationLoading = () => {
  return (
    <div className="flex animate-pulse flex-col gap-y-1 pt-1">
      <div className="flex h-[33px] items-center gap-x-2 px-2">
        <div className="bg-info-200 h-4 w-4 rounded-full" />
        <div className="bg-info-200 h-3 w-1/2 rounded-full" />
      </div>
      <div className="flex h-[33px] items-center gap-x-2 px-2">
        <div className="bg-info-200 h-4 w-4 rounded-full" />
        <div className="bg-info-200 h-3 w-3/4 rounded-full" />
      </div>
      <div className="flex h-[33px] items-center gap-x-2 px-2">
        <div className="bg-info-200 h-4 w-4 rounded-full" />
        <div className="bg-info-200 h-3 w-3/4 rounded-full" />
      </div>
      <div className="flex h-[33px] items-center gap-x-2 px-2">
        <div className="bg-info-200 h-4 w-4 rounded-full" />
        <div className="bg-info-200 h-3 w-1/2 rounded-full" />
      </div>
      <div className="flex h-[33px] items-center gap-x-2 px-2">
        <div className="bg-info-200 h-4 w-4 rounded-full" />
        <div className="bg-info-200 h-3 w-3/4 rounded-full" />
      </div>
      <div className="flex h-[33px] items-center gap-x-2 px-2">
        <div className="bg-info-200 h-4 w-4 rounded-full" />
        <div className="bg-info-200 h-3 w-2/3 rounded-full" />
      </div>
    </div>
  );
};
